import { RouteObject } from "react-router-dom";

import { IUserInfo } from 'app/models';
import { getUser, store } from 'app/state';
import { ModuleLayout } from 'app/layouts';

import Profile from './profile';

export const routes: RouteObject[] = [
  { path: '', element: <ModuleLayout />,
    handle: { exclude: true },
    children: [
      { path: 'profile', element: <Profile />,
        loader: () => getUser(store.getState())!,
        handle: { title: (user: IUserInfo) => (user?.username ?? 'Guest') },
      },
    ],
  },
];
